export const CONFIG_STUDIO_API = `uje`;